import React, { } from "react"
import styled from 'styled-components'
import media from 'cssMix/index'

export default ({ SignText, imgUrl }) => {
    return (
      <WrongPage>
        <ErrorImg imgUrl={imgUrl}/>
        <SignText />
      </WrongPage>
    )
}


// style
const WrongPage = styled.div`
width:100%;
height: 100%;
display:flex;
flex-direction: column;
align-items:center;
justify-content:center;
background:#242830;
position: relative;
overflow:hidden;
`

const ErrorImg = styled.div`
height:300px;
width:300px;
background:${props=>`url(${props.imgUrl}) no-repeat` };
background-size:contain;
margin-bottom:56px;
${media.mobile`
    width:200px;
    height:200px;
`}
`